// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect, useState} from 'react';

export const use_client = (alive_timeout = 5000)=>{
    const [is_client, set_is_client] = useState(false);
    const [is_client_alive, set_is_client_alive] = useState(false);
    useEffect(()=>{
        const timer = setTimeout(()=>{ set_is_client(true); }, 0);
        return ()=>{ clearTimeout(timer); };
    }, []);
    useEffect(()=>{
        if (!is_client)
            return;
        const timer = setTimeout(()=>{
            return set_is_client_alive(true);
        }, alive_timeout);
        const handle_mouse_move = ()=>{
            window.removeEventListener('mousemove', handle_mouse_move);
            return set_is_client_alive(true);
        };
        window.addEventListener('mousemove', handle_mouse_move);
        return ()=>{
            clearTimeout(timer);
            window.removeEventListener('mousemove', handle_mouse_move);
        };
    }, [is_client]);
    return {is_client, is_client_alive};
};
